import type { BadgeTone } from "../../components/ui/badge";

export type UsageEventType = "batch_call" | "adhoc_call" | "retry_call" | "platform_fee" | "top_up";

export interface UsageEvent {
  id: string;
  timestamp: string; // ISO
  type: UsageEventType;
  campaign: string | null;
  durationSec: number | null;
  amount: number;        // negative = spend, positive = credit
  balanceAfter: number;
}

export interface Invoice {
  id: string;
  period: string;
  issuedAt: string;
  amount: number;
  status: "paid" | "pending";
}

export interface AutoRechargeRules {
  enabled: boolean;
  threshold: number; // recharge when wallet drops below this
  amount: number;    // top-up amount
}

export const USAGE_EVENT_META: Record<UsageEventType, { label: string; tone: BadgeTone }> = {
  batch_call:    { label: "Batch Call", tone: "brand" },
  adhoc_call:    { label: "Ad-hoc Call", tone: "neutral" },
  retry_call:    { label: "Retry Call", tone: "violet" },
  platform_fee:  { label: "Platform Fee", tone: "warning" },
  top_up:        { label: "Top-up", tone: "success" },
};

export const USAGE_TYPE_OPTIONS: { value: UsageEventType | "all"; label: string }[] = [
  { value: "all", label: "All Events" },
  { value: "batch_call", label: "Batch Calls" },
  { value: "adhoc_call", label: "Ad-hoc Calls" },
  { value: "retry_call", label: "Retry Calls" },
  { value: "platform_fee", label: "Platform Fees" },
  { value: "top_up", label: "Top-ups" },
];
